var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarketBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 1.66797H2.75497C2.95999 1.66797 3.0625 1.66797 3.14499 1.70567C3.21769 1.73889 3.27929 1.79232 3.32246 1.85959C3.37145 1.93592 3.38595 2.0374 3.41494 2.24035L3.80936 5.0013M3.80936 5.0013L4.68594 11.4441C4.79718 12.2617 4.85279 12.6705 5.04825 12.9783C5.22049 13.2494 5.46741 13.465 5.7593 13.5991C6.09056 13.7513 6.50312 13.7513 7.32826 13.7513H14.4598C15.2453 13.7513 15.638 13.7513 15.959 13.61C16.242 13.4854 16.4847 13.2845 16.6601 13.0298C16.8589 12.741 16.9324 12.3552 17.0794 11.5836L18.1824 5.79271C18.2342 5.52114 18.26 5.38536 18.2225 5.27922C18.1897 5.18611 18.1248 5.10771 18.0395 5.05798C17.9422 5.0013 17.804 5.0013 17.5275 5.0013H3.80936ZM8.33317 17.5013C8.33317 17.9615 7.96007 18.3346 7.49984 18.3346C7.0396 18.3346 6.6665 17.9615 6.6665 17.5013C6.6665 17.0411 7.0396 16.668 7.49984 16.668C7.96007 16.668 8.33317 17.0411 8.33317 17.5013ZM14.9998 17.5013C14.9998 17.9615 14.6267 18.3346 14.1665 18.3346C13.7063 18.3346 13.3332 17.9615 13.3332 17.5013C13.3332 17.0411 13.7063 16.668 14.1665 16.668C14.6267 16.668 14.9998 17.0411 14.9998 17.5013Z",
    stroke: "#2E3C40",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketBlack);
export default __webpack_public_path__ + "static/media/MarketBlack.87877a2b3fdb97c3d6c66245d697f25e.svg";
export { ForwardRef as ReactComponent };